import PaymentDurationModal from '../Modal/settingsCustomModal'
import { TopDisplay } from '../../../../ui-components';
import {CircularProgress, styled} from '@mui/material';
import {useState} from 'react';
import PaymentDurationTable from './Table';
import CreatePaymentDuration from './Edit-CreatePaymentEdition';
import apiCall from '../../../../utils/apiCall';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';


interface PaymentDurationDetails {
  Id: number;
  PaymentType: string;
  StartDate: string;
  EndDate: string;
  IsActive: boolean;
}

 const Main = () => {
  const [openCreatePaymentDuration, setOpenCreateTemplateDuration] = useState(false);
  // const paymentDurationData = [
  //   {
  //     action: 'appplication',
  //     startDate: '12th May 1998',
  //     endDate: '13th May 2005',
  //     status: 'Active'
  //   }
  // ]

  const getPaymentDuration = async (): Promise<PaymentDurationDetails[]> => {
    return (await apiCall().get(`/SetUp/GetAllActivePaymentDuration`)).data?.Data as PaymentDurationDetails[]
  }


  const getPaymentDurationQuery = useQuery(['get-payment-duration'], getPaymentDuration)

  const paymentDurationData = getPaymentDurationQuery?.data 
  const paymentDurationError = getPaymentDurationQuery?.error as AxiosError

  const Button = (props:any)=>{
    return (<button {...props}>{props.children}</button>)
  }

  const CreateBtn = ({...props})=> <Button {...props} 
  style={{ backgroundColor:"#11643C",color:"#fff",border:"none",outline:"none",padding:"15px 20px", borderRadius:"5px"}}>
    Create Payment Duration
  </Button>

  const handleOpenCreatePaymentDurationModal = () => {
    setOpenCreateTemplateDuration(true);
  }

  return (
    <Container>
      <TopDisplay title="Payment Duration" subTitle="Settings" Btn = {<CreateBtn style = {{cursor: 'pointer'}} onClick = {handleOpenCreatePaymentDurationModal}/>} />
      <InnerContainer>
      {
          getPaymentDurationQuery.isFetching ?
          <CircularProgress 
            sx={{
                fontSize: '1rem',
                marginInline: 'auto',
                display: 'block',
                marginBlock: '2rem'
            }}/> :
            getPaymentDurationQuery?.isError ?
            <StyledError>{paymentDurationError?.message}</StyledError> :
            <PaymentDurationTable data = {paymentDurationData}/>
      }
      </InnerContainer>
      
      <PaymentDurationModal 
        cancel ={setOpenCreateTemplateDuration} 
        open = {openCreatePaymentDuration}
        maxWidth = {'712px'}
        header={'Payment Duration'}
        showrightIcon={false}
        content = {
          <CreatePaymentDuration  cancel = {setOpenCreateTemplateDuration}/>
        }
    />
    </Container>
  )
}

export default Main;

const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`

 const InnerContainer = styled('div')`
    display: flex;
    flex-direction: column;
    gap:10px;
    margin-top:20px;
    width: 100%;
    margin-block-start: 41px;
`

const Container= styled('div')`
    padding: 0 48px 48px;
    width:100%;
`